<template>
  <v-container>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <b>Province</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ province_name_en }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>District</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ district_name_en }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Sub-district</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ sub_district_name_en }}
      </v-col>
      <v-col
        v-if="request_type == 'maid'"
        cols="4"
        md="2"
      >
        <b>Type of Building:</b>
      </v-col>
      <v-col
        v-if="request_type == 'maid'"
        cols="8"
        md="4"
      >
        {{ type_of_building }}
      </v-col>
      <v-col
        v-if="request_type == 'maid'"
        cols="4"
        md="2"
      >
        <b>Floor:</b>
      </v-col>
      <v-col
        v-if="request_type == 'maid'"
        cols="8"
        md="4"
      >
        {{ floor }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Address Detail:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ address_detail }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LocationEdit',
  props: ['request_type', 'province_name_en', 'district_name_en', 'sub_district_name_en', 'type_of_building', 'floor', 'address_detail']
}
</script>
